import { render, staticRenderFns } from "./about.vue?vue&type=template&id=47210431&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47210431",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderType01: require('/var/www/html/jayuvillage/components/headerType01.vue').default,Quicks: require('/var/www/html/jayuvillage/components/quicks.vue').default,Navigation: require('/var/www/html/jayuvillage/components/navigation.vue').default})
